var _path, _path2, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_186)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3C6.35786 3 3 6.35786 3 10.5C3 13.0163 4.23917 15.2431 6.14056 16.6036C6.23852 17.1786 6.30356 18.0893 6 19C5.5 20.5 5 21 5 21C5 21 6.5 21 8.5 20C10.5 19 12 18 12 18H13.5C17.6421 18 21 14.6421 21 10.5C21 6.35786 17.6421 3 13.5 3H10.5Z",
    fill: "#C6DDFF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3C6.35786 3 3 6.35786 3 10.5C3 13.0163 4.23917 15.2431 6.14056 16.6036C6.23852 17.1786 6.30356 18.0893 6 19C5.5 20.5 5 21 5 21C5 21 6.5 21 8.5 20C10.5 19 12 18 12 18H13.5C17.6421 18 21 14.6421 21 10.5C21 6.35786 17.6421 3 13.5 3H10.5Z",
    fill: "url(#paint0_linear_4_186)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9338 11.7273V11.5568C10.9338 11.1662 10.9645 10.8549 11.0261 10.6229C11.0877 10.3909 11.1788 10.205 11.2995 10.0653C11.4203 9.9233 11.5682 9.79545 11.7434 9.68182C11.8949 9.58239 12.0299 9.48651 12.1483 9.39418C12.269 9.30185 12.3637 9.2036 12.4324 9.09943C12.5034 8.99527 12.5389 8.87689 12.5389 8.74432C12.5389 8.62595 12.5105 8.52178 12.4537 8.43182C12.3968 8.34186 12.3199 8.27202 12.2228 8.2223C12.1258 8.17259 12.0181 8.14773 11.8997 8.14773C11.7718 8.14773 11.6535 8.17732 11.5446 8.23651C11.438 8.29569 11.3516 8.37737 11.2853 8.48153C11.2214 8.5857 11.1895 8.70644 11.1895 8.84375H9.37127C9.37601 8.32292 9.49438 7.90033 9.72638 7.57599C9.95839 7.24929 10.2662 7.01018 10.6497 6.85866C11.0332 6.70478 11.4546 6.62784 11.9139 6.62784C12.4205 6.62784 12.8727 6.70241 13.2704 6.85156C13.6681 6.99834 13.9818 7.22088 14.2115 7.51918C14.4411 7.8151 14.5559 8.18561 14.5559 8.63068C14.5559 8.91714 14.5062 9.16927 14.4068 9.38707C14.3097 9.60251 14.1736 9.79309 13.9984 9.95881C13.8256 10.1222 13.6232 10.2713 13.3912 10.4062C13.2207 10.5057 13.0775 10.6087 12.9615 10.7152C12.8455 10.8194 12.7579 10.9389 12.6987 11.0739C12.6395 11.2064 12.6099 11.3674 12.6099 11.5568V11.7273H10.9338ZM11.8002 14.1136C11.5256 14.1136 11.2901 14.0178 11.0936 13.826C10.8994 13.6319 10.8036 13.3963 10.8059 13.1193C10.8036 12.8494 10.8994 12.6186 11.0936 12.4268C11.2901 12.2351 11.5256 12.1392 11.8002 12.1392C12.0607 12.1392 12.2903 12.2351 12.4892 12.4268C12.6904 12.6186 12.7922 12.8494 12.7946 13.1193C12.7922 13.304 12.7437 13.4721 12.649 13.6236C12.5566 13.7727 12.4359 13.8923 12.2868 13.9822C12.1376 14.0698 11.9754 14.1136 11.8002 14.1136Z",
    fill: "#386FF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_186",
    x1: 7,
    y1: 3.64286,
    x2: 23.2,
    y2: 16.2429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.faff106b413c06e5f5eda8470bdc882f.svg";
export { ForwardRef as ReactComponent };